export const blockIconsCommunicationForum = (
	<span className='material-symbols-outlined'>forum</span>
);
